module.exports = "<div id=\"admin\"><h1 class=\"header\">Admin beállítások</h1></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/apps/admin/apps.admin.component.pug
// module id = ./src/app/modules/apps/admin/apps.admin.component.pug
// module chunks = main